import { useState, useEffect } from 'react';

/**
 * Returns a debounced copy of `value` that updates only after
 * `delay` ms of silence. Use for search inputs and autocomplete.
 */
export function useDebounce<T>(value: T, delay: number = 300): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
}
